import React, { useState } from 'react';
import axios from 'axios';

const AddProblem = () => {

    const [formData, setFormData] = useState({
      problemRating: "",
      problemLink: "",
      timeNeeded: "",
      problemStatus: "",
      problemName: "",
    });

    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await axios.post(
          "https://cp-tracker-backend.onrender.com/problem/addProblem",
          formData
        );
        console.log("Form submitted:", response.data);
        window.location.href = "/";
        // Do something with the response data if needed
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    };

    return (
      <div>
        <h1>Add Problem</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Problem Rating:</label>
            <input
              type="text"
              name="problemRating"
              value={formData.problemRating}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Problem Name:</label>
            <input
              type="text"
              name="problemName"
              value={formData.problemName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Problem Link:</label>
            <input
              type="text"
              name="problemLink"
              value={formData.problemLink}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Time Needed (minutes):</label>
            <input
              type="number"
              name="timeNeeded"
              value={formData.timeNeeded}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Problem Status:</label>
            <select
              name="problemStatus"
              value={formData.problemStatus}
              onChange={handleChange}
            >
              <option value="">Select Status</option>
              <option value="withoutTestCase">Without Test Case</option>
              <option value="withTestCase">With Test Case</option>
              <option value="withEditorial">With Editorial</option>
              <option value="withSolution">With Solution</option>
              <option value="disaster">Disaster</option>
            </select>
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    );
};

export default AddProblem;